import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

function smoothScrollTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

/** Smooth-scroll to top on route changes and same-page logo/link clicks. */
export function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    smoothScrollTop()
  }, [pathname])

  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      const anchor = (event.target as Element | null)?.closest?.('a')
      if (!anchor) return
      if (anchor.target && anchor.target !== '_self') return

      const href = anchor.getAttribute('href')
      if (!href || href.startsWith('mailto:') || href.startsWith('tel:')) return

      let url: URL
      try {
        url = new URL(href, window.location.origin)
      } catch {
        return
      }

      if (url.origin !== window.location.origin) return

      // Same path: React Router won't remount, so scroll here.
      if (url.pathname === window.location.pathname) {
        smoothScrollTop()
      }
    }

    document.addEventListener('click', onClick)
    return () => document.removeEventListener('click', onClick)
  }, [])

  return null
}
